import Container from '@material-ui/core/Container';
import SearchIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { InputBase, makeStyles } from '@material-ui/core';
import { T } from '../../Services/Localization';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import React from 'react';
import { fade } from '@material-ui/core/styles';

import bgImage from '../../assests/catalog-bg.jpg';
import { NavLink } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundImage: `url(${bgImage})`,
    backgroundSize: 'cover',
    backgroundPositionY: 'center',
    backgroundBlendMode: 'multiply',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
  },
  activeLink: {
    '& button': {
      color: theme.palette.secondary.dark,
    },
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  button: {
    margin: theme.spacing(1),
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  // Search
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    // width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    height: 48,
    fontSize: 24,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      // width: 120,
      '&:focus': {
        // width: 200,
      },
    },
  },
}));

interface Props {
  onSearch: (e: React.ChangeEvent<{ value: string; name: string }>) => void;
  navButtons: { name: string; title: string }[];
}

const Navigation: React.FC<Props> = ({ onSearch, navButtons }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.heroContent}>
      <Container maxWidth="sm">
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            fullWidth
            name={'searchString'}
            onChange={e => onSearch(e)}
            placeholder={T('placeholder.search')}
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ 'aria-label': 'search' }}
          />
        </div>

        <div className={classes.heroButtons}>
          <Grid container spacing={1} justify="center">
            {navButtons.map(group => (
              <Grid item key={group.name}>
                <NavLink
                  to={'/' + group.name}
                  className={classes.link}
                  activeClassName={classes.activeLink}>
                  <Button variant="contained" color="secondary">
                    {group.title}
                  </Button>
                </NavLink>
              </Grid>
            ))}
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default Navigation;
